import { useCallback, useMemo } from 'react'
import { useAuthStore } from '@/store/authStore'

const EMPTY_PERMISSIONS = {} as Record<string, string[]>

export function usePermissions() {
  const rawPermissions = useAuthStore((state) => state.user?.permissions)
  const permissions = useMemo(() => rawPermissions ?? EMPTY_PERMISSIONS, [rawPermissions])

  const can = useCallback((resource: string, action: string): boolean => {
    if (!permissions) return false
    if (permissions['*']?.includes('*')) return true
    const actions = permissions[resource]
    if (!actions) return false
    return actions.includes(action) || actions.includes('*')
  }, [permissions])

  const canAccessResource = useCallback((resource: string): boolean => {
    if (!permissions) return false
    if (permissions['*']?.includes('*')) return true
    const actions = permissions[resource]
    return Array.isArray(actions) && actions.length > 0
  }, [permissions])

  return { can, canAccessResource, permissions }
}
